<template>
	<div class="chinaEuropeTrain">
		<Header :typeHeader="'defaultHeader'">
			<!-- banner -->
			<img slot="headerImage" :src="imgList.bannerImg" alt="">
		</Header>
		<div class="TopTitle" data-aos="fade-right">
			<!-- data-aos="fade-up-left" -->
			<div class=""> {{ $store.state.navShow == true ? $route.name : $route.meta.EnName }} </div>
		</div>
		<div class="ContenNewsCenterDetail">
			<p class="tableTitleTitleTop">{{ nowShowNews.title }}</p>
			<div class="ContenNewsCenterTime">
				<div class="source"> {{ $store.state.navShow == true ? '来源:' : 'News Source : ' }}{{ nowShowNews.origin_name }}
				</div> | <div class="time"> {{ nowShowNews.inputtime }} </div>
			</div>
			<div class="NewsCenter" v-html="nowShowNews.content">
			</div>
		</div>
		<!-- 		<div class="buttonImg">
			<img :src="imgList.bottonImg">
		</div> -->
		<div class="latestNews">
			<div class="tableTitleTitle_2">{{ $store.state.navShow == true ? '最新新闻' : 'Latest News' }}</div>
			<div class="latestNewsList" v-for="(item, index) in $store.state.navShow == true ? latestNews : latestNewsE"
				:key="index">
				<div :class="[index < 3 ? 'latestNewsListCon' : 'ConNone']" @click="JupmLatestNews(item.id)"> {{ item.title }}
				</div>
			</div>
			<div class="bannerCons" data-aos="fade-up">
				<div class="showCon1">
					<div class="showConTop">
						<el-row type="flex" justify="space-between" class="showConTopImg" :gutter="10">
							<el-col :span="6" v-for="(item, index) in showConImgList.list0.top" :key="index">
								<img :src="$store.state.navShow == true ? item.img : item.imgE" @click="JupmPath(item.path)">
							</el-col>
						</el-row>
					</div>
					<div class="showConbBtton">
						<el-row type="flex" class="showConTopImg" :gutter="20">
							<el-col :span="21">
								<img class="showConBttonImg_1"
									:src="$store.state.navShow == true ? showConImgList.list0.img5.img : showConImgList.list0.img5.imgE"
									@click="JupmPath(showConImgList.list0.img5.path)">
							</el-col>
							<el-col :span="10">
								<img class="showConBttonImg_2"
									:src="$store.state.navShow == true ? showConImgList.list0.img6.img : showConImgList.list0.img6.imgE"
									@click="JupmPath(showConImgList.list0.img6.path)">
							</el-col>
							<el-col :span="10">
								<img class="showConBttonImg_3"
									:src="$store.state.navShow == true ? showConImgList.list0.img7.img : showConImgList.list0.img7.imgE"
									@click="JupmPath(showConImgList.list0.img7.path)">
							</el-col>
						</el-row>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footers.vue";
export default {
	components: {
		Header,
		Footer
	},
	data() {
		return {
			imgList: {
				bannerImg: require('@/assets/newsCenter/banner.jpg'),
			},
			nowShowNews: {},
			latestNews: [],
			latestNewsE: [],
			showConImgList: {
				list0: {
					top: [
						{
							img: require("@/assets/header/business1.png"),
							imgE: require("@/assets/header/business1_E.png"),
							title: '海运服务',
							path: '/CR_oceanShipping'
						},
						{
							img: require("@/assets/header/business2.png"),
							imgE: require("@/assets/header/business2_E.png"),
							title: '汽车运输',
							path: '/CR_automobileTransportation'
						},
						{
							img: require("@/assets/header/business3.png"),
							imgE: require("@/assets/header/business3_E.png"),
							title: '空运服务',
							path: '/CR_airServices'
						},
						// {
						// 	img: require("@/assets/header/business4.png"),
						// 	imgE: require("@/assets/header/business4_E.png"),
						// 	title: '中俄清关',
						// 	path: '/CR_customsClearance'
						// },
						{
							img: require("@/assets/header/business15.png"),
							imgE: require("@/assets/header/business15_E.png"),
							title: '境外承运',
							path: ''
						},
					],
					img5: {
						img: require("@/assets/header/business5.png"),
						imgE: require("@/assets/header/business5_E.png"),
						title: '中欧运输',
						path: '/chinaEuropeTrain'
					},
					img6: {
						img: require("@/assets/header/business6.png"),
						imgE: require("@/assets/header/business6E.png"),
						title: '国际贸易',
						path: '/internationalTrade'
					},
					img7: {
						img: require("@/assets/header/business7.png"),
						imgE: require("@/assets/header/business7E.png"),
						title: '中欧班列境外服务商',
						path: '/CR_overseasServiceProvider'
					}
				},
			},
		}
	},
	mounted() {
		console.log('新闻详情');
		// 获取到新闻中心页面跳转时传过来的 新闻id
		const xinwenid = Number(this.$route.query.newId)
		this.newsDetailsFun(xinwenid);
		this.newsDetailsFunE(xinwenid)


	},
	methods: {
		/**
		 * 新闻详情 接口函数
		 * 罗锦炜
		 * 2021-12-07
		 */
		newsDetailsFun(xwid) {
			this.$axios.get('/api/Index/newsInfo', {
				params: {
					id: xwid // 新闻id
				}
			}).then(res => {
				console.log('新闻详情=>', res)
				const {
					data
				} = res
				if (data.code === 1) {
					// 当前展示的新闻信息
					this.nowShowNews = data.data.info
					// console.log('当前展示的新闻=>', this.nowShowNews)
					this.latestNews = data.data.news

				} else {
					this.$message({
						showClose: true,
						message: '新闻详情' + res.data.msg,
						type: 'error'
					})
				}
			})
		},
		newsDetailsFunE(xwid) {
			this.$axios.get('/apien/Index/newsInfo', {
				params: {
					id: xwid // 新闻id
				}
			}).then(res => {
				console.log('新闻详情=>', res)
				const {
					data
				} = res
				if (data.code === 1) {
					// 当前展示的新闻信息
					// this.nowShowNews = data.data.info
					// console.log('当前展示的新闻=>', this.nowShowNews)
					this.latestNewsE = data.data.news

				} else {
					this.$message({
						showClose: true,
						message: '新闻详情' + res.data.msg,
						type: 'error'
					})
				}
			})
		},
		/**
		 * 跳转最新新闻
		 * 罗锦炜
		 * 2021-12-08
		 * */
		JupmLatestNews(newId) {
			this.newsDetailsFun(newId)
			document.documentElement.scrollTop = 0
			// this.$router.push({
			// 	path: '/newsDetail',
			// 	query: {
			// 		newId: newId
			// 	}
			// })
		},

		/**
		 * 跳转
		 * 罗锦炜
		 * 2021-12-08
		 * */
		JupmPath(path) {
			console.log(this.$router.history.current.fullPath);
			if (path == this.$router.history.current.fullPath) {
				document.documentElement.scrollTop = 0
			} else {
				this.$router.push({
					path: path,
					// query: {
					// 	newId: newId
					// }
				})
			}

		}

	}
}
</script>
<!-- 头部 -->
<style lang="less">
.ConNone {
	display: none;
}

.TopTitle {
	width: 92%;
	height: 4.95rem;
	position: relative;
	margin: 0 4%;
	top: -3.2rem;
	border-bottom: 1px solid rgba(204, 204, 204, .5);

	&>div {
		position: absolute;
		top: 1.25rem;
		font-size: 1rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #FFFFFF;
		padding: 1.2rem 3.375rem 1.2rem 0.75rem;
		background: #2e67b1 linear-gradient(270deg, rgba(3, 0, 0, .15), hsla(0, 0%, 100%, .15));
	}
}
</style>

<style lang="less">
.ContenNewsCenterDetail {
	width: 92%;
	margin: 0 4%;
	margin-top: -1.25rem;
	margin-bottom: 1.25rem;
	border-bottom: 0.03125rem solid #CCCCCC;

	.ContenNewsCenterTime {
		display: flex;
		font-size: 0.825rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666;
		margin-bottom: .7rem;

		.source {
			margin-right: 0.625rem;
		}

		.time {
			margin-left: 0.625rem;
		}
	}

	.NewsCenter {
		width: 100%;
		padding-bottom: 2.5rem;
	}

}

.latestNews {
	width: 92%;
	margin: 0 4%;

	.latestNewsList {

		.latestNewsListCon {
			font-size: 0.7875rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			text-align: left;
			margin: 1.1875rem 0 1.1875rem 0;
			padding-bottom: 1.1875rem;
			border-bottom: 0.03125rem solid #CCCCCC;

		}
	}
}


.bannerCons {
	width: 100%;
	// height: 332px * @z;
	margin-bottom: 1.875rem;

	img {
		border-radius: 3px;
	}

	.showCon1 {
		width: 100%;
		margin-bottom: 0.625rem;

		.showConTop {
			width: 100%;
			display: flex;
			justify-content: space-around;
			margin-bottom: 0.3125rem;

			.showConTopImg {
				width: 100%;
				height: 4.875rem;
			}
		}

		.showConbBtton {
			width: 100%;
			display: flex;
			justify-content: space-around;

			.showConTopImg {
				width: 100%;
				height: 4.875rem;

				img {
					height: 78px;
				}

				.el-col {
					padding-left: 5px !important;
					padding-right: 5px !important;
				}

				.el-col-21 {
					width: 85% !important;
				}
			}
		}
	}
}



// 小标题
.tableTitleTitleTop {
	// margin: 1.875rem 0 0.625rem 0;
	font-size: 1rem;
	font-family: Microsoft YaHei;
	font-weight: bold;
	color: #2E67B1;
	text-align: left;
	margin-bottom: 0.7375rem;
}

// 小标题
.tableTitleTitle_2 {
	// margin: 1.875rem 0 0.625rem 0;
	font-size: 0.95rem;
	font-family: Microsoft YaHei;
	font-weight: bold;
	color: #2E67B1;
	text-align: left;
	padding-bottom: 0.925rem;
	border-bottom: 0.03125rem solid #CCCCCC;
	margin-top: 1.65rem;
}
</style>
